import { render, staticRenderFns } from "./PostPress.vue?vue&type=template&id=770ce934&scoped=true&"
import script from "./PostPress.vue?vue&type=script&lang=js&"
export * from "./PostPress.vue?vue&type=script&lang=js&"
import style0 from "./PostPress.vue?vue&type=style&index=0&id=770ce934&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770ce934",
  null
  
)

export default component.exports